// Each value is the suffix its range carries through the team-metrics payload —
// avgPraxisScore7Days — which leaves all time as the empty one: the payload keys
// its all-time figures with no suffix, and the leaderboard endpoint reads all
// time as the absence of `days`.
export const DATE_RANGE_OPTIONS = [
  { value: "", label: "All Time" },
  { value: "7Days", label: "Last 7 days" },
  { value: "30Days", label: "Last 30 days" },
];

// All time is what the all_time_date_range flag adds, so with the flag off only
// the windows are on offer.
export const WINDOWED_RANGES = DATE_RANGE_OPTIONS.filter((range) => range.value);
